import styled from 'styled-components';

export default styled.div`
text-align: left;
padding: 10 px;
margin: 5px;
h4 {
    font-size:18px;
    font-weight: bold;
}
* {
    border: none !important;
}
`;
